import Image from "@/components/AppImage";
import Link from "@/components/common/DashboardLink";
import add_new from "/public/images/add-new.png";
import blockchain_card from "/public/images/blockchain-card.png";
import option from "/public/images/icon/option.png";
import paylio_card from "/public/images/paylio-card.png";
import paypal_card from "/public/images/paypal-card.png";
import visa_card from "/public/images/visa-card.png";

const LinkedPaymentSystem = () => {
  return (
    <>
      <div className="section-text d-flex align-items-center justify-content-between">
        <div>
          <h6>Funding &amp; settlement</h6>
          <p className="mdr small mt-1 mb-0">
            Inbound: ACH only. Default credit: Polygon USDC. Optional
            auto-convert: one extra token (POL) max.
          </p>
        </div>
        <div className="right-side">
          <div className="dropdown-area">
            <button
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              <Image src={option} alt="icon" />
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li>
                <Link className="dropdown-item" href="/account">
                  Manage bank &amp; wallets
                </Link>
              </li>
              <li>
                <Link className="dropdown-item" href="/deposit-money/step-1">
                  Link another ACH bank
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-6">
          <div className="single-card">
            <button
              type="button"
              className="reg w-100"
              data-bs-toggle="modal"
              data-bs-target="#cardMod"
              title="Primary linked bank (ACH)">
              <Image src={visa_card} alt="Linked bank ACH" className="w-100" />
            </button>
          </div>
        </div>
        <div className="col-6">
          <div className="single-card">
            <button
              type="button"
              className="reg w-100"
              data-bs-toggle="modal"
              data-bs-target="#cardMod"
              title="Default: Polygon USDC">
              <Image
                src={paylio_card}
                alt="Polygon USDC default"
                className="w-100"
              />
            </button>
          </div>
        </div>
        <div className="col-6">
          <div className="single-card">
            <button
              type="button"
              className="reg w-100"
              data-bs-toggle="modal"
              data-bs-target="#cardMod"
              title="Optional auto-convert token">
              <Image
                src={paypal_card}
                alt="Optional POL auto-convert"
                className="w-100"
              />
            </button>
          </div>
        </div>
        <div className="col-6">
          <div className="single-card">
            <button
              type="button"
              className="reg w-100"
              data-bs-toggle="modal"
              data-bs-target="#cardMod"
              title="On-chain settlement">
              <Image
                src={blockchain_card}
                alt="Polygon network"
                className="w-100"
              />
            </button>
          </div>
        </div>
        <div className="col-6">
          <div className="single-card">
            <button
              type="button"
              className="reg w-100"
              data-bs-toggle="modal"
              data-bs-target="#addcardMod">
              <Image src={add_new} alt="Add funding source" className="w-100" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LinkedPaymentSystem;
